import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("删除")

import { ref, reactive, computed, onBeforeMount, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import dayjs from 'dayjs'
import { getNumber, formatTime } from '@/utils/index'
import { formatNumber } from '@/utils/index'
import Api from '@/http/modules/index'
import { size } from 'mathjs'
import payment from '@/http/api/finance/payment'

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

let {
    // 代付凭证_查询
    'POST/order/payment_voucher/roster/query':rosterQueryApi,
    // 代付凭证_名单管理_删除
    'DELETE/order/payment_voucher/roster/{payerId}':rosterDelApi,
    // 管理员验证
  'GET/isAdmin': isAdminApi,
} = Api
const pageInfo=reactive({
    page:1,
    size:10,
    total:0
})
const isAdmin=ref(false)
const tableHeight = window.innerHeight-200
const queryInfo=ref<any>({})
const loadingDtata=ref(false)
const rosterLists=ref([])
const getRosterLists=(isReset:boolean=false)=>{
    if(isReset){
        pageInfo.page=1
        queryInfo.value={}
    }
    let {page,size}=pageInfo
    let params={
        page,size,
        query:{
            type:queryInfo.value.type,
            payerId:queryInfo.value.payerId
        }
    }
    loadingDtata.value=true
    rosterQueryApi(params).then((res:any)=>{
        rosterLists.value=res.data
        pageInfo.total=res.rowCount
    }).finally(()=>{
        loadingDtata.value=false
    })
}
const flilterType=(type:any)=>{
    switch(type){
        case 1 :
            return "黑名单"
        case 2 :
            return '白名单'
        case 3:
            return "本次忽略"
    }
}
const delHandle=(row:any)=>{
    ElMessageBox.confirm('确定删除？',{confirmButtonText:"确定",cancelButtonText:"取消"}).then(()=>{
        rosterDelApi({payerId:row.payerId}).then(()=>{
            ElMessage.success("删除成功")
            getRosterLists(true)
        })
    })
}
expose({
    getRosterLists
})
onMounted(()=>{
    getRosterLists()
    isAdminApi().then((res:any)=>{
        isAdmin.value=res
    })
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "点击搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, { inline: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "状态：" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      clearable: "",
                      modelValue: queryInfo.value.type,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryInfo.value.type) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "黑名单",
                          value: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "白名单",
                          value: 2
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "付款ID：" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: queryInfo.value.payerId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryInfo.value.payerId) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (getRosterLists())),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      maxHeight: tableHeight,
      class: "mt-10",
      data: rosterLists.value,
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "payerId",
          label: "付款ID"
        }),
        _createVNode(_component_el_table_column, {
          prop: "payType",
          label: "支付方式"
        }),
        _createVNode(_component_el_table_column, {
          prop: "type",
          label: "状态"
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(flilterType(row.type)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "operationName",
          label: "操作人"
        }),
        _createVNode(_component_el_table_column, {
          prop: "operationTime",
          format: (row)=>_unref(dayjs)(row.operationTime).format('YYYY-MM-DD HH:mm:ss'),
          label: "操作时间"
        }, null, 8, ["format"]),
        (isAdmin.value)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              prop: "ops",
              label: "操作"
            }, {
              default: _withCtx(({row}) => [
                _createVNode(_component_el_link, {
                  underline: false,
                  type: "danger",
                  onClick: ($event: any) => (delHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loadingDtata.value]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(pageInfo).total,
      currentPage: _unref(pageInfo).page,
      "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((_unref(pageInfo).page) = $event)),
      "page-size": _unref(pageInfo).size,
      "onUpdate:page-size": _cache[4] || (_cache[4] = ($event: any) => ((_unref(pageInfo).size) = $event)),
      class: "mb-5 mt-5",
      onSizeChange: _cache[5] || (_cache[5] = ()=>getRosterLists()),
      onCurrentChange: _cache[6] || (_cache[6] = ()=>getRosterLists()),
      "page-sizes": [10, 30, 50, 100, 500, 1000, 2000],
      layout: "sizes, prev, pager, next, total, jumper"
    }, null, 8, ["total", "currentPage", "page-size"])
  ]))
}
}

})